import React from "react";
import { FaTimes, FaCalendarAlt, FaExternalLinkAlt } from "react-icons/fa";

function BookingDetailsModal({ booking, onClose }) {
  if (!booking) return null;

  return (
    <div className="topmate-modal-overlay" onClick={onClose}>
      <div className="topmate-modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "650px" }}>
        <div className="modal-header">
          <h3>
            <FaCalendarAlt style={{ color: "#38bdf8" }} /> Session Booking Details
          </h3>
          <button className="modal-close-btn" onClick={onClose} aria-label="Close modal">
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <div className="modal-details-grid">
            <div className="modal-detail-item">
              <span className="modal-detail-label">Customer Name</span>
              <span className="modal-detail-value">{booking.customerName}</span>
            </div>
            <div className="modal-detail-item">
              <span className="modal-detail-label">Customer Email</span>
              <span className="modal-detail-value">{booking.customerEmail}</span>
            </div>
            <div className="modal-detail-item">
              <span className="modal-detail-label">Customer Phone</span>
              <span className="modal-detail-value">{booking.customerPhone || "N/A"}</span>
            </div>
            <div className="modal-detail-item">
              <span className="modal-detail-label">Service Title</span>
              <span className="modal-detail-value">{booking.serviceName}</span>
            </div>
            <div className="modal-detail-item">
              <span className="modal-detail-label">Booking Time (IST)</span>
              <span className="modal-detail-value" style={{ color: "#38bdf8" }}>
                {booking.bookingDateIST}
              </span>
            </div>
            <div className="modal-detail-item">
              <span className="modal-detail-label">Duration</span>
              <span className="modal-detail-value">{booking.durationMinutes || 30} minutes</span>
            </div>
            <div className="modal-detail-item">
              <span className="modal-detail-label">Portfolio Booking ID</span>
              <span className="modal-detail-value" style={{ fontFamily: "monospace", fontSize: "0.8rem", color: "#38bdf8" }}>
                {booking.portfolioBookingId}
              </span>
            </div>
            <div className="modal-detail-item">
              <span className="modal-detail-label">Topmate Booking ID</span>
              <span className="modal-detail-value" style={{ fontFamily: "monospace", fontSize: "0.8rem" }}>
                {booking.topmateBookingId}
              </span>
            </div>
            <div className="modal-detail-item">
              <span className="modal-detail-label">Status</span>
              <span className="modal-detail-value">
                <span className={`status-pill ${booking.status?.toLowerCase()}`}>{booking.status}</span>
              </span>
            </div>
            <div className="modal-detail-item">
              <span className="modal-detail-label">Payment Status</span>
              <span className="modal-detail-value">
                <span className="status-pill paid">{booking.paymentStatus || "Paid"}</span> ({booking.currency || "INR"} {booking.amount || 0})
              </span>
            </div>
            <div className="modal-detail-item" style={{ gridColumn: "1 / -1" }}>
              <span className="modal-detail-label">Meeting Join Link</span>
              <span className="modal-detail-value">
                {booking.googleMeetUrl ? (
                  <a
                    href={booking.googleMeetUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#38bdf8", textDecoration: "underline", display: "inline-flex", alignItems: "center", gap: "6px" }}
                  >
                    {booking.googleMeetUrl} <FaExternalLinkAlt style={{ fontSize: "0.75rem" }} />
                  </a>
                ) : (
                  <span style={{ color: "#94a3b8" }}>
                    Sent natively to the customer by Topmate
                  </span>
                )}
              </span>
            </div>
            <div className="modal-detail-item" style={{ gridColumn: "1 / -1" }}>
              <span className="modal-detail-label">Automatic Email Status</span>
              <span className="modal-detail-value">
                {booking.emailSent ? (
                  <span style={{ color: "#34d399" }}>
                    Confirmation email sent automatically ({booking.emailSentCount || 1} time(s))
                  </span>
                ) : (
                  <span style={{ color: "#fbbf24" }}>
                    {booking.bookingDateIST === "Unavailable"
                      ? "Pending verified session appointment time"
                      : "Pending automatic dispatch"}
                  </span>
                )}
              </span>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button type="button" className="topmate-btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default BookingDetailsModal;
